import { DateTime } from 'luxon';
import { useMemo } from 'react';
import { AvailableQueryParamKeys, useGetQueryParams } from './useGetQueryParams';

export const usePreselectedDateTimeQuery = () => {
  const preselectedDateTimeIso = useGetQueryParams(AvailableQueryParamKeys.CV_PRESELECTED_DATETIME_QUERY_PARAM);

  return useMemo(() => {
    if (preselectedDateTimeIso) {
      const preselectedDateTime = DateTime.fromISO(preselectedDateTimeIso);

      if (preselectedDateTime.isValid) {
        return {
          preselectedDateTime,
          preselectedDateTimeIso,
        };
      }
    }

    return {
      preselectedDateTime: null,
      preselectedDateTimeIso,
    };
  }, [preselectedDateTimeIso]);
};
